import * as Backbone from 'backbone';

const ajax = require('sma.common/ajax');
const modals = require('sma.common/components/modals.js');
const Dropdown = require('sma.admin/components/dropdowns/dropdown');

const { ExistingRecordModal } = require('sma.applicant/tasks/global_tasks');
const { Popover } = require('sma.common/components/popover');
const SubmitConfirm = require('sma.applicant/confirm_submit_modal');

const awardedTempl = require('sma.applicant/application/partials/decision.mustache');

const STRINGS = {
	show: gettext('Show'),
	hide: gettext('Hide'),
	download: gettext('Download'),
	reset: gettext('Reset'),
	collaborators: gettext('Collaborators'),
	edit: gettext('Edit'),
	reset_task: gettext('Reset task'),
	reset_task_confirm: gettext('Are you sure you want to reset this \
		task? You will lose all associated data'),
	awarded: gettext('Awarded'),
	declined: gettext('Declined'),
	you_have_been_awarded: gettext('You have been awarded: '),
	decision_title: gettext('A decision has been made on your application'),
};

class TaskView extends Backbone.View {
	get events() {
		return {
			'click .sma-js-instructions-toggle': 'toggleInstructions',
			'click .sma-js-applicant-collaborators': 'collaborators',
			'click .sma-js-mark-complete': 'markCompleteClicked',
			'click .sma-js-application-decision': 'decisionInfo',
			'click .sma-js-use-existing-data': 'useExistingClicked',
			'click .sma-js-application-submit-button': 'showApplicationSubmitModal',
			'click .sma-js-application-next-task-button': 'openPrevNextTask',
			'click .sma-js-application-prev-task-button': 'openPrevNextTask',
		};
	}

	initialize(config) {
		this.setElement($('body'));

		this.task_id = config.task_id;
		this.submission_id = config.submission_id;
		this.submission = config.submission;
		this.task_record_id = config.task_record_id;
		this.task_type = config.task_type;

		this.name = config.name;
		this.can_reset = config.can_reset;
		this.can_edit = config.can_edit;
		this.is_completed = config.is_completed;
		this.is_not_started = config.is_not_started;
		this.edit_after_complete = config.edit_after_complete;
		this.show_reuse_data = config.show_reuse_data;
		let callback = (records) => {
			if (records && records.length > 0) {
				let popover = new Popover({
					attachTo: $('body').find('.sma-js-existing-records-info'),
					content: gettext('You have previously completed this task and can reuse your data here.')
				});

				$('body').find('.sma-js-existing-records-info').on('click', () => {
					popover.toggle();
				});

				if (this.show_reuse_data && this.is_not_started) {
					this.reuse_existing.hideErrors();
					this.reuse_existing.modal.show();
				}
			} else {
				$('body').find('.sma-js-use-existing-data').fadeOut(0);
				$('body').find('.sma-js-existing-records-info').fadeOut(0);
			}
		};

		this.reuse_existing = new ExistingRecordModal(
			this.submission_id, this.task_record_id, callback, this.task_type
		);

		const $taskItems = $('.sma-applicant-task-list-mini-item');
		const $selectedTaskItem = $taskItems.filter('.selected');
		const $prevTaskButton = $('.sma-js-application-prev-task-button');
		const $nextTaskButton = $('.sma-js-application-next-task-button');

		if(!$taskItems.length || $taskItems.length === 1) {
			$prevTaskButton.parent().hide();
		} else {
			if($selectedTaskItem.is(':first-child')) {
				$prevTaskButton.hide();
			} else if($selectedTaskItem.is(':last-child')) {
				$nextTaskButton.hide();
			}
		}

		this.render();
	}

	get $instructions() {
		return $('.sma-js-applicant-task-description');
	}

	get $actionMenu() {
		return $('.sma-js-applicant-task-menu');
	}

	render() {
		this.renderActionMenu();
	}

	renderActionMenu() {
		let items = [{
			name: 'download',
			text: STRINGS.download,
			ariaLabel: 'Download (opens in a new tab)',
			action: (_data) => {
				let config = {
					download_format: 'as_single_file',
					submission_ids: this.submission_id,
					task_ids: this.task_id,
					include_application_profiles: true,
					task_record_ids: [this.task_record_id]
				};

				ajax.post({
					url: reverse('download-redirect'),
					alertOnSuccess: false,
					data: config,
					callback: (response) => {
						if (response.url) {
							window.open(response.url, '_blank');
						}
					}
				});
			}
		}];

		if (this.can_reset && this.can_edit) {
			items.push({
				name: 'reset',
				text: STRINGS.reset,
				action: (_data) => {
					new modals.Confirm(
						STRINGS.reset_task,
						STRINGS.reset_task_confirm,
						() => {
							let url = reverse('task-reset', {
								submission_id: this.submission_id,
								task_record_id: this.task_record_id,
							});

							ajax.post({
								url: url,
								callback: (response) => {
									window.location = response.return_url;
								}
							});
						},
					);
				}
			});
		}

		if (this.can_edit && this.is_completed) {
			items.push({
				name: 'edit',
				text: STRINGS.edit,
				action: (_data) => {
					let url = reverse('task-reopen', {
						submission_id: this.submission_id,
						task_record_id: this.task_record_id,
					});

					ajax.post({
						url: url,
						callback: (response) => {
							window.location = response.return_url;
						}
					});
				}
			});
		}

		let dropdown = new Dropdown({
			items: items,
			title: '<i class="nc-icon-mini ui-2_menu-dots" aria-hidden="true"></i>',
			noCaret: true,
			btnclass: 'btn-link js-sma-leftnav',
			rightAligned: true,
			ariaLabel: gettext('Perform action on task'),
		}).$el.addClass('dropdown');

		this.$actionMenu.html(dropdown);
	}

	renderPreview() {
		if (this.can_edit) {
			return;
		}
		ajax.get({
			url: reverse('submission-taskrecord-preview', {
				submission_id: this.submission_id,
				task_record_id: this.task_record_id
			}),
			callback: (response) => {
				$('.sma-js-rendered-form').html(response.html);
			}
		});
	}

	toggleInstructions(e) {
		e.preventDefault();

		this.$instructions.toggle();
		$(e.currentTarget).text(
			this.$instructions.is(':visible') ? STRINGS.hide : STRINGS.show);
	}

	collaborators(e) {
		e.preventDefault();

		let modal = new modals.AjaxFormModal({
			destroyOnClose: true,
			size: 'lg',
			title: STRINGS.invite_collaborators,
			onSuccess: (data) => {
				if (data.redirect) {
					window.location = data.redirect;
				}
			},
		});

		modal.addToStack(
			'AddCollaborators',
			new modals.AjaxFormContent(
				reverse('get-collaborators', {
					app_id: this.submission_id,
				}) + '?edit=True', {
				autoShow: true,
				destroyOnClose: true,
				title: STRINGS.collaborators,
				buttons: [{
					label: gettext('Send Invite'),
					cls: 'btn btn-primary btn-loud sma-js-collaborator-invite',
					form: 'addCollaboratorForm',
					type: 'submit',
					handler: (_modal) => { }
				}]
			}
			)
		);

		modal.show();
	}

	markCompleteClicked(e) {
		e.preventDefault();

		let $form = $(e.currentTarget).closest('form');
		let needsDocuSignSigning = $(e.currentTarget).data('docusignSigning') === true;

		let submit = () => {
			if (needsDocuSignSigning) {
				this.showDocuSignHangTightInline();
			}
			$form.submit();
		};

		if (this.edit_after_complete) {
			submit();
			return;
		}

		new modals.Confirm(
			gettext('Task confirmation'),
			interpolate(
				gettext('The task <strong>%(name)s</strong> will be locked once you complete it.'),
				{ name: this.name }, true
			),
			submit, {
			no: gettext('CANCEL'),
			yes: gettext('COMPLETE TASK')
		}
		);
	}

	showDocuSignHangTightInline() {
		// Rendering PDF + creating/resuming the DocuSign envelope happens synchronously
		// server-side in DocuSignTaskSignView before the browser gets redirected to
		// DocuSign — this replaces each DocuSign question's own placeholder content
		// (rather than a full-page modal) with a "hang tight" loading state so it sits
		// inline inside the question until the browser navigates away.
		let $placeholders = $('.docusign-signature-placeholder .sma-js-docusign-placeholder-content');
		if (!$placeholders.length) {
			return;
		}

		if (!$('#sma-js-docusign-hang-tight-style').length) {
			$('head').append([
				'<style id="sma-js-docusign-hang-tight-style">',
				'@keyframes smaDocuSignHangTightSpin { to { transform: rotate(360deg); } }',
				'.sma-js-docusign-hang-tight-spinner {',
				'display: inline-block; width: 20px; height: 20px; flex-shrink: 0;',
				'border: 2px solid #dee2e6; border-top-color: #6c757d; border-radius: 50%;',
				'animation: smaDocuSignHangTightSpin 0.8s linear infinite;',
				'}',
				'</style>',
			].join(' '));
		}

		$placeholders.html([
			'<span class="sma-js-docusign-hang-tight-spinner"></span>',
			'<div>',
			`<strong style="color:#212529;">${gettext("Hang tight...")}</strong><br>`,
			`<span class="text-muted small">${gettext("We're confirming your signing details with Docusign.")}</span>`,
			'</div>',
		].join(''));
	}

	useExistingClicked(e) {
		e.preventDefault();

		this.reuse_existing.hideErrors();
		this.reuse_existing.modal.show();
	}

	decisionInfo(e) {
		e.preventDefault();

		let content = awardedTempl({
			submission: this.submission,
			strings: STRINGS
		});

		let config = {
			autoShow: true,
			destroyOnClose: true,
			title: STRINGS.decision_title,
		};

		new modals.ContentModal(content, config);
	}

	showApplicationSubmitModal(e) {
		e.preventDefault();

		new SubmitConfirm({ appId: this.submission.id });
	}

	openPrevNextTask(e) {
		e.preventDefault();

		let btnId = e.currentTarget.id;
		const selectedTaskItem = $('.sma-applicant-task-list-mini-item.selected');
		if(btnId === 'next' && selectedTaskItem.next().length) {
			selectedTaskItem.next().find('a')[0].click();
		} else if(btnId === 'prev' && selectedTaskItem.prev().length) {
			selectedTaskItem.prev().find('a')[0].click();
		}
	}
}


module.exports = {
	TaskView: TaskView
};
